import React from "react";
import SignUpForm from "./SignForm";

function SignUp() {
  return (
    <div style={{ margin: "0 auto" }}>
      <SignUpForm />
    </div>
  );
}

export default SignUp;
